import React from "react";
import { Link } from "react-router-dom";
import { BusinessHeader, BusinessFooter } from "./BusinessHome";

const Row = ({ title, us, others, none }) => (
  <tr className="border-b border-brand-dark/5">
    <td className="py-2 pr-4 font-medium text-brand-dark">{title}</td>
    <td className="py-2 px-2 text-center text-brand-orange font-bold">{us}</td>
    <td className="py-2 px-2 text-center text-brand-dark/60">{others}</td>
    <td className="py-2 px-2 text-center text-brand-dark/40">{none}</td>
  </tr>
);

export default function BusinessFeatures() {
  return (
    <div className="min-h-screen">
      <BusinessHeader />
      <div className="max-w-4xl mx-auto px-4 py-10">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-brand-dark">Everything Tabdine gives you.</h1>
        <p className="text-brand-dark/60 mt-2">Broken into what customers see, what your team runs, and what owners track.</p>

        <div className="grid md:grid-cols-3 gap-3 mt-6">
          {[
            { title: "For Customers", items: ["NFC / QR ordering", "Video Menu (reel)", "Reviews tab", "Loyalty stamps", "Split bill"] },
            { title: "For Restaurants", items: ["Live Orders kanban", "Kitchen Display Screen", "Menu Manager (with video)", "Page Tabs Manager", "Offers Manager", "Reviews Manager"] },
            { title: "For Owners", items: ["Analytics + peak hours", "Multi-outlet (soon)", "Subscription mgmt", "Referral programme"] },
          ].map((g) => (
            <div key={g.title} className="bg-white rounded-2xl border border-brand-dark/5 p-4">
              <div className="font-heading font-semibold text-brand-dark">{g.title}</div>
              <ul className="mt-2 text-sm space-y-1 text-brand-dark/70">
                {g.items.map((i) => (
                  <li key={i} className="flex items-start gap-2"><span className="text-brand-orange mt-1">✓</span>{i}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <h2 className="font-heading text-2xl font-bold text-brand-dark mt-10">Tabdine vs the alternatives</h2>
        <div className="mt-3 bg-white rounded-2xl border border-brand-dark/5 p-4 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-brand-dark/10">
                <th className="py-2 text-left"></th>
                <th className="py-2 px-2 text-center text-brand-orange">Tabdine</th>
                <th className="py-2 px-2 text-center">Traditional POS</th>
                <th className="py-2 px-2 text-center">No system</th>
              </tr>
            </thead>
            <tbody>
              <Row title="NFC / QR ordering" us="✓" others="Rare" none="—" />
              <Row title="Kitchen display" us="✓" others="Add-on" none="—" />
              <Row title="Loyalty stamps" us="Built-in" others="Third-party" none="—" />
              <Row title="Video menu" us="✓" others="—" none="—" />
              <Row title="Reviews on your page" us="✓" others="—" none="—" />
              <Row title="Setup time" us="Under 1 day" others="Weeks" none="Instant chaos" />
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center">
          <Link to="/business/demo" className="bg-brand-orange text-white px-6 py-3 rounded-full font-medium hover:bg-brand-orange-dark">
            Book a Demo →
          </Link>
        </div>
      </div>
      <BusinessFooter />
    </div>
  );
}
